export default "__VITE_ASSET__XmX_NFIZ__"